"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var BrandLogo = function (props) {
    var name = props.name, imageUrl = props.imageUrl, pageUrl = props.pageUrl;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "sq-frame mr-3" },
            react_1.default.createElement("img", { className: "img-fluid", id: "previewCatalogCompanyLogo", src: imageUrl })),
        react_1.default.createElement("a", { href: pageUrl },
            react_1.default.createElement("span", { className: "cap", id: "previewCatalogCompanyName" }, name)))
    // <div className={style.BrandLogo}>
    //   <img className={style.img} src={imageUrl} />
    //   <div className={style.name}>{name}</div>
    // </div>
    );
};
BrandLogo.propTypes = {
    name: prop_types_1.default.string,
    imageUrl: prop_types_1.default.string,
};
exports.default = BrandLogo;
